import request from '~/apis/axios'
import type { IResponse } from '~/apis/axios/config'
import type {
  dropsListParam,
  dropsListResult,
  dropsMainParam,
  dropsMainResult,
  dropsPackageListResult,
  EventPromotionPointParam,
  EventPromotionPointResult,
  payDropsInfoParam,
  payDropsInfoResult,
  payProcessPayConfirmParam,
  payProcessPayConfirmResult,
  payProcessPayReqParam,
  payProcessPayReqResult,
  PayProcessPayResParam,
  PayProcessPayResResult,
} from '~/apis/point/type'

/**
 * 2.5.1 메인 point 조회
 */
export const DropsMain = (
  params: dropsMainParam,
): Promise<IResponse<dropsMainResult>> => {
  return request.get({ url: '/jadooApiV1/userPointInfo', params })
}

/**
 * 2.5.2 point 내역
 */
export const DropsList = (
  params: dropsListParam,
): Promise<IResponse<dropsListResult>> => {
  return request.get({ url: '/jadooApiV1/userPointList', params })
}

/**
 * 2.5.3 충전소 패키지 리스트 조회
 */
export const DropsPackageList = (): Promise<
  IResponse<dropsPackageListResult>
> => {
  return request.get({ url: '/jadooApiV1/payPointPackage' })
}

/**
 * 2.5.4 1. 충전하기 정보
 */
export const payDropsInfo = (
  params: payDropsInfoParam,
): Promise<IResponse<payDropsInfoResult>> => {
  return request.get({ url: '/jadooApiV1/payPointInfo', params })
}

/**
 * 2.5.4 2. 토스 통신 요청 - 납부 DB 저장 및 토스 호출 데이터
 */
export const payProcessReq = (
  data: payProcessPayReqParam,
): Promise<IResponse<payProcessPayReqResult>> => {
  return request.post({ url: '/jadooApiV1/payPointReq', data })
}

/**
 * 2.5.4 3. 토스 통신 요청 - 납부 결제 승인 처리 및 결과 DB 저장
 */
export const payProcessConfirm = (
  data: payProcessPayConfirmParam,
): Promise<IResponse<payProcessPayConfirmResult>> => {
  return request.post({ url: '/jadooApiV1/payPointConfirm', data })
}

/**
 * 2.5.4 4. 납부 온라인 결제 결과 정보
 */
export const payResultInfo = (
  data: PayProcessPayResParam,
): Promise<IResponse<PayProcessPayResResult>> => {
  return request.post({ url: '/jadooApiV1/payPointRes', data })
}

/**
 * 2.5.5 프로모션 적립
 */
export const putEventPromotion = (
  data: EventPromotionPointParam,
): Promise<IResponse<EventPromotionPointResult>> => {
  return request.put({ url: '/jadooApiV1/userPointInfo', data })
}
